/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaImage, 
  FaColumns, 
  FaEye, 
  FaGlobe, 
  FaCheckCircle, 
  FaExclamationCircle, 
  FaTimesCircle, 
  FaTrash, 
  FaPlus,
  FaLinkedin,
  FaTwitter,
  FaInstagram,
  FaCloudUploadAlt,
  FaBullseye
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import axiosInstance from '../apis/axiosConfig';
import './EditAbout.css';

const EditAbout = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0); // 0 to 4
  const [loading, setLoading] = useState(true);

  // Sections toggle list
  const [sections, setSections] = useState([
    { id: 2, section: 'Content + Wide Banner', icon: FaImage, status: 1, subtitle: 'Who We Are', validation: 'validation-success' },
    { id: 5, section: 'Meet Our Directors', icon: FaEye, status: 1, subtitle: 'Our Leadership', validation: 'validation-success' },
    { id: 4, section: 'Left Image & Right Content', icon: FaColumns, status: 1, subtitle: 'Our Presence', validation: 'validation-success' },
    { id: 3, section: 'Our Foundation', icon: FaBullseye, status: 1, subtitle: 'Vision, Mission & Values', validation: 'validation-success' },
    { id: 8, section: 'SEO Manager', icon: FaGlobe, status: 1, subtitle: 'Default', validation: 'validation-success' }
  ]);

  // Form State for each Section
  // Section 2: Content + Wide Banner (Who We Are Collage)
  const [contentWideBanner, setContentWideBanner] = useState({
    image: '',
    image2: '',
    image3: '',
    alt: 'About Aristo Team',
    heading: 'About Aristo India',
    description: 'With our passionate beginning two decades ago, Aristo is a leading manufacturer & supplier of wardrobe shutters, furniture & aluminum profiles. With our global presence panning across 14 countries (including Russia, Europe, China, India, USA, New Zealand, UAE, Kazakhstan, Azerbaijan, Bahrain, Qatar & more).\n\nAristo globally employees more than 800 employees for daily operations & continues to steadfast our investments into full-fledged R&D centers, software development & technology so as to optimize cost. Currently Aristo works with 1000 stores worldwide.'
  });

  // Section 5: Meet Our Directors (Our Leadership)
  const [directorsSection, setDirectorsSection] = useState({
    tag: 'OUR LEADERSHIP',
    heading: 'Meet Our Directors',
    description: 'Guided by vision, driven by passion. Our leadership team brings decades of experience and a commitment to excellence in every project we deliver.',
    directors: [
      {
        id: '1',
        name: 'Mr. Sanjay Arora',
        role: 'Managing Director',
        image: '',
        bio: 'With over 20 years of experience in modular solutions, Mr. Sanjay Arora leads with a vision for innovation and quality. His expertise drives our mission to deliver excellence.',
        linkedin: '',
        twitter: '',
        instagram: '',
        status: 1
      },
      {
        id: '2',
        name: 'Mr. Rahul Mehta',
        role: 'Director – Operations',
        image: '',
        bio: 'Mr. Rahul Mehta ensures seamless execution and operational excellence. His strategic approach and attention to detail keep every project on track and beyond expectations.',
        linkedin: '',
        twitter: '',
        instagram: '',
        status: 1
      },
      {
        id: '3',
        name: 'Mr. Vikas Sharma',
        role: 'Director – Design & Innovation',
        image: '',
        bio: 'Mr. Vikas Sharma brings creativity and innovation to life. His passion for design and functionality creates spaces that are both beautiful and highly functional.',
        linkedin: '',
        twitter: '',
        instagram: '',
        status: 1
      }
    ]
  });

  // Section 4: Left Image & Right Content
  const [leftImageRightContent, setLeftImageRightContent] = useState({
    image: '',
    alt: 'Map',
    heading: 'LEADING WARDROBE & KITCHEN MANUFACTURER BRAND',
    description: "Aristo India represents a dynamic joint venture between Aristo Russia and the esteemed Kelachandra business house, boasting a rich legacy of over 100 years in India. This partnership is geared towards expanding Aristo's presence in India and reaching further into the Indian Subcontinent, including countries like Sri Lanka and Bangladesh.\n\nFor 15 years, Aristo has been synonymous with delivering premium wardrobing and kitchen solutions in India, captivating the hearts of over 2 lakh customers with our commitment to quality and excellence. Today, we proudly stand with over 400 partners spread across India and operate from six state-of-the-art production facilities.",
    highlights: ''
  });

  // Section 3: Our Foundation (Vision, Mission & Core Values)
  const [foundationSection, setFoundationSection] = useState({
    tag: 'OUR FOUNDATION',
    heading: 'Vision. Mission. Values That Drive Us.',
    vision_title: 'Vision',
    vision_desc: 'To be the trusted leader in delivering the greatest experiences that exceeds customer expectations based on the values of ownership, integrity, transparency, fairness, & environmental stewardship.',
    mission_title: 'Mission',
    mission_points: 'Craftsmanship & Premium Design\nCustomer-Centric Service\nIntegrated Systems & Transparency\nBrand Tone',
    image: '',
    alt: 'Core Values'
  });

  // Section 8: SEO Manager
  const [seo, setSeo] = useState({
    meta_title: 'Best manufacturer for Custom made Designer Wardrobes and Kitchen',
    meta_description: 'Aristo India is a joint venture between Aristo Russia & Kelachandra business house. Premium quality Wardrobe, Sliding doors, Kitchen cabinets, Office Furniture Manufacturing Company from Bangalore',
    meta_keywords: 'Aristo India, Sliding wardrobe company in bangalore, Wardrobes ideas online, Modern Wardrobes'
  });

  const fileInputRefs = useRef({});

  useEffect(() => {
    fetchAboutData();
  }, []);

  const fetchAboutData = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get('/pages/about');
      if (res && res.data && res.data.success) {
        const { page, contents, sections: dbSections } = res.data;

        // Parse SEO
        if (page) {
          setSeo({
            meta_title: page.meta_title || seo.meta_title,
            meta_description: page.meta_description || seo.meta_description,
            meta_keywords: page.meta_keywords || seo.meta_keywords
          });
        }

        // Parse section toggles if available
        if (dbSections && Array.isArray(dbSections) && dbSections.length > 0) {
          setSections(prev => prev.map(s => {
            const found = dbSections.find(d => String(d.id) === String(s.id));
            if (found) {
              const secStatus = (found.status === 1 || found.status === '1') ? 1 : 0;
              return { 
                ...s, 
                status: secStatus,
                validation: secStatus === 1 ? 'validation-success' : 'validation-error'
              };
            }
            return s;
          }));
        }

        // Parse Section Contents from DB
        if (contents && Array.isArray(contents)) {
          contents.forEach(item => {
            if (!item.content) return;
            let parsed = null;
            try {
              parsed = typeof item.content === 'string' ? JSON.parse(item.content) : item.content;
            } catch (e) {
              console.error("JSON parse error for section", item.section_id, e);
            }

            if (item.section_id === 2 && Array.isArray(parsed) && parsed.length > 0) {
              setContentWideBanner(prev => ({ ...prev, ...parsed[0] }));
            } else if (item.section_id === 5 && parsed) {
              setDirectorsSection(prev => {
                if (parsed.directors && Array.isArray(parsed.directors)) {
                  return { ...prev, ...parsed };
                }
                return prev;
              });
            } else if (item.section_id === 4 && Array.isArray(parsed) && parsed.length > 0) {
              let opt = item.optional_content || '';
              setLeftImageRightContent(prev => ({ ...prev, ...parsed[0], highlights: opt }));
            } else if (item.section_id === 3 && parsed) {
              setFoundationSection(prev => {
                const fData = Array.isArray(parsed) ? parsed[0] : parsed;
                return { ...prev, ...fData };
              });
            }
          });
        }
      }
    } catch (err) {
      console.error("Error loading About data:", err);
      toast.error("Failed to load About Us page configuration");
    } finally {
      setLoading(false);
    }
  };

  // Helper to format image URL
  const getImageUrl = (image) => {
    if (!image) return null;
    if (image.startsWith('blob:') || image.startsWith('http')) return image;
    const backendHost = (process.env.REACT_APP_BACKEND || (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL.split('/api')[0]) || 'http://localhost:8000').replace(/\/$/, '');
    return `${backendHost}/uploads/${image}`;
  };

  // Toggle switch handler for sections (persists immediately to backend)
  const handleToggleSectionStatus = async (idx, e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    const targetSection = sections[idx];
    if (!targetSection) return;
    const newStatus = targetSection.status === 1 ? 0 : 1;

    const updated = [...sections];
    updated[idx] = {
      ...updated[idx],
      status: newStatus,
      validation: newStatus === 1 ? 'validation-success' : 'validation-error'
    };
    setSections(updated);

    try {
      await axiosInstance.patch('/pages/about', {
        sections: updated,
        contents: [
          { section_id: 2, content: [contentWideBanner], status: updated[0]?.status ?? 1 },
          { section_id: 5, content: directorsSection, status: updated[1]?.status ?? 1 },
          { section_id: 4, content: [leftImageRightContent], optional_content: leftImageRightContent.highlights, status: updated[2]?.status ?? 1 },
          { section_id: 3, content: [foundationSection], status: updated[3]?.status ?? 1 }
        ]
      });
      toast.success(`${targetSection.section} status updated!`);
    } catch (err) {
      console.error("Failed to auto-save section toggle status:", err);
    }
  };

  // Server File Upload Handler
  const handleImageFileChange = async (e, targetSetter, fieldName = 'image') => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('image', file);
      try {
        const res = await axiosInstance.post('/products/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        const filename = res.data.filename;
        if (typeof targetSetter === 'function') {
          targetSetter(prev => ({ ...prev, [fieldName]: filename }));
        }
        toast.success('Image uploaded successfully!');
      } catch (err) {
        console.error('Image upload failed:', err);
        toast.error('Failed to upload image');
      }
    }
  };

  // Director Actions
  const handleAddDirector = () => {
    const newDir = {
      id: Date.now().toString(),
      name: '',
      role: '',
      image: '',
      bio: '',
      linkedin: '',
      twitter: '',
      instagram: '',
      status: 1
    };
    setDirectorsSection(prev => ({
      ...prev,
      directors: [...prev.directors, newDir]
    }));
    toast.success('New Director added!');
  };

  const handleRemoveDirector = (idx) => {
    setDirectorsSection(prev => ({
      ...prev,
      directors: prev.directors.filter((_, i) => i !== idx)
    }));
    toast.info('Director removed');
  };

  const handleDirectorFieldChange = (idx, field, value) => {
    setDirectorsSection(prev => {
      const updated = [...prev.directors];
      updated[idx] = { ...updated[idx], [field]: value };
      return { ...prev, directors: updated };
    });
  };

  const handleDirectorImageUpload = async (e, idx) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('image', file);
      try {
        const res = await axiosInstance.post('/products/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        const filename = res.data.filename;
        handleDirectorFieldChange(idx, 'image', filename);
        toast.success('Director photo uploaded successfully!');
      } catch (err) {
        console.error('Director photo upload failed:', err);
        toast.error('Failed to upload director photo');
      }
    }
  };

  // Save All Changes to Database
  const handleSave = async () => {
    try {
      const contentsPayload = [
        { section_id: 2, content: [contentWideBanner], status: sections[0]?.status ?? 1 },
        { section_id: 5, content: directorsSection, status: sections[1]?.status ?? 1 },
        { section_id: 4, content: [leftImageRightContent], optional_content: leftImageRightContent.highlights, status: sections[2]?.status ?? 1 },
        { section_id: 3, content: [foundationSection], status: sections[3]?.status ?? 1 }
      ];

      const payload = {
        sections: sections,
        contents: contentsPayload,
        meta_title: seo.meta_title,
        meta_description: seo.meta_description,
        meta_keywords: seo.meta_keywords
      };

      const res = await axiosInstance.patch('/pages/about', payload);
      if (res.data && res.data.success) {
        toast.success('About Us page saved successfully!');
      } else {
        toast.error(res.data.message || 'Failed to update About Us page');
      }
    } catch (err) {
      console.error("Save error:", err);
      toast.error('Server error while saving About Us configuration');
    }
  };

  if (loading) {
    return (
      <div className="edit-about-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <h3 style={{ color: '#c4a882' }}>Loading About Us Configuration...</h3>
      </div>
    );
  }

  return (
    <div className="edit-about-container animate-fade-up">
      {/* Page Header */}
      <div className="edit-about-header">
        <h1 className="edit-about-title">About Us</h1>
      </div>

      {/* Main Grid: Sticky Sidebar Navigation & Scrollable Right Panel */}
      <div className="edit-about-grid">
        
        {/* Sticky Left Navigation Sidebar */}
        <div className="edit-about-sidebar">
          <ul className="edit-about-nav-list">
            {sections.map((sec, idx) => {
              const IconComp = sec.icon;
              return (
                <li 
                  key={sec.id || idx}
                  className={`edit-about-nav-item ${activeTab === idx ? 'active' : ''}`}
                  onClick={() => setActiveTab(idx)}
                >
                  <div className="edit-about-nav-left">
                    <span className="edit-about-nav-icon"><IconComp /></span>
                    <div className="edit-about-nav-text">
                      <span className="nav-item-title">{sec.section}</span>
                      <span className="nav-item-subtitle">{sec.subtitle}</span>
                    </div>
                  </div>
                  
                  <div className="edit-about-nav-right">
                    {/* Status Badge */}
                    <span className={`status-indicator ${sec.validation}`}>
                      {sec.validation === 'validation-success' && <FaCheckCircle />}
                      {sec.validation === 'validation-warning' && <FaExclamationCircle />}
                      {sec.validation === 'validation-error' && <FaTimesCircle />}
                    </span>

                    {/* Toggle Switch */}
                    <label className="switch-toggle" onClick={(e) => e.stopPropagation()}>
                      <input 
                        type="checkbox" 
                        checked={sec.status === 1}
                        onChange={(e) => handleToggleSectionStatus(idx, e)}
                      />
                      <span className="switch-slider"></span>
                    </label>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Right Scrollable Content Panel */}
        <div className="edit-about-content-panel">
          
          {activeTab < 4 && sections[activeTab]?.status === 0 ? (
            <div className="oops-disabled-card animate-fade-up">
              <h2 className="oops-title">Oops!</h2>
              <p className="oops-message">
                Please enable or activate <strong>{sections[activeTab].section}</strong> to modify the content.
              </p>
              <button 
                type="button" 
                className="btn-enable-activate"
                onClick={() => handleToggleSectionStatus(activeTab)}
              >
                Enable / Activate
              </button>
            </div>
          ) : (
            <>
              {/* TAB 0: Content + Wide Banner (Who We Are 3-Image Collage) */}
              {activeTab === 0 && (
            <div className="tab-pane animate-fade-up">
              <h2 className="edit-about-panel-title">Who We Are (Content + 3-Image Collage)</h2>
              
              <div className="about-card-block">
                {/* 3 Collage Images Row */}
                <div style={{ marginBottom: '1.5rem' }}>
                  <label className="label-custom" style={{ fontSize: '1rem', color: '#c4a882', marginBottom: '0.75rem', display: 'block' }}>
                    Collage Photos (3 Images)
                  </label>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1rem' }}>
                    
                    {/* Image 1 (Top Wide Banner) */}
                    <div className="image-uploader-box">
                      <label className="label-custom" style={{ fontSize: '0.85rem' }}>
                        1. Top Main Banner <span className="req">*</span>
                      </label>
                      <div 
                        className="image-preview-wrapper"
                        style={{ height: '140px' }}
                        onClick={() => fileInputRefs.current['contentWide1']?.click()}
                      >
                        {contentWideBanner.image ? (
                          <>
                            <img src={getImageUrl(contentWideBanner.image)} alt={contentWideBanner.alt || 'Top Banner'} className="uploaded-preview-img" />
                            <div className="image-delete-overlay" onClick={(e) => { e.stopPropagation(); setContentWideBanner({ ...contentWideBanner, image: '' }); }}>
                              <FaTrash />
                            </div>
                          </>
                        ) : (
                          <div className="upload-placeholder-content">
                            <FaCloudUploadAlt className="upload-icon" />
                            <span>Upload Top Wide Banner</span>
                          </div>
                        )}
                      </div>
                      <input 
                        type="file" 
                        accept="image/*"
                        style={{ display: 'none' }}
                        ref={el => fileInputRefs.current['contentWide1'] = el}
                        onChange={(e) => handleImageFileChange(e, setContentWideBanner, 'image')}
                      />
                      <span className="dimensions-note">Wide photo (Aspect 16:7)</span>
                    </div>

                    {/* Image 2 (Bottom Left Photo) */}
                    <div className="image-uploader-box">
                      <label className="label-custom" style={{ fontSize: '0.85rem' }}>
                        2. Bottom Left Photo <span className="opt">(Wardrobe/Office)</span>
                      </label>
                      <div 
                        className="image-preview-wrapper"
                        style={{ height: '140px' }}
                        onClick={() => fileInputRefs.current['contentWide2']?.click()}
                      >
                        {contentWideBanner.image2 ? (
                          <>
                            <img src={getImageUrl(contentWideBanner.image2)} alt="Bottom Left" className="uploaded-preview-img" />
                            <div className="image-delete-overlay" onClick={(e) => { e.stopPropagation(); setContentWideBanner({ ...contentWideBanner, image2: '' }); }}>
                              <FaTrash />
                            </div>
                          </>
                        ) : (
                          <div className="upload-placeholder-content">
                            <FaCloudUploadAlt className="upload-icon" />
                            <span>Upload Bottom-Left Photo</span>
                          </div>
                        )}
                      </div>
                      <input 
                        type="file" 
                        accept="image/*"
                        style={{ display: 'none' }}
                        ref={el => fileInputRefs.current['contentWide2'] = el}
                        onChange={(e) => handleImageFileChange(e, setContentWideBanner, 'image2')}
                      />
                      <span className="dimensions-note">Square/Landscape (Aspect 4:3)</span>
                    </div>

                    {/* Image 3 (Bottom Right Photo) */}
                    <div className="image-uploader-box">
                      <label className="label-custom" style={{ fontSize: '0.85rem' }}>
                        3. Bottom Right Photo <span className="opt">(Kitchen/Showroom)</span>
                      </label>
                      <div 
                        className="image-preview-wrapper"
                        style={{ height: '140px' }}
                        onClick={() => fileInputRefs.current['contentWide3']?.click()}
                      >
                        {contentWideBanner.image3 ? (
                          <>
                            <img src={getImageUrl(contentWideBanner.image3)} alt="Bottom Right" className="uploaded-preview-img" />
                            <div className="image-delete-overlay" onClick={(e) => { e.stopPropagation(); setContentWideBanner({ ...contentWideBanner, image3: '' }); }}>
                              <FaTrash />
                            </div>
                          </>
                        ) : (
                          <div className="upload-placeholder-content">
                            <FaCloudUploadAlt className="upload-icon" />
                            <span>Upload Bottom-Right Photo</span>
                          </div>
                        )}
                      </div>
                      <input 
                        type="file" 
                        accept="image/*"
                        style={{ display: 'none' }}
                        ref={el => fileInputRefs.current['contentWide3'] = el}
                        onChange={(e) => handleImageFileChange(e, setContentWideBanner, 'image3')}
                      />
                      <span className="dimensions-note">Square/Landscape (Aspect 4:3)</span>
                    </div>

                  </div>
                </div>

                <div className="card-content-grid">
                  {/* Text Inputs */}
                  <div style={{ gridColumn: '1 / -1' }}>
                    <div className="form-group-custom">
                      <label className="label-custom">Heading / Title <span className="opt">(Optional)</span></label>
                      <input 
                        type="text" 
                        className="input-custom"
                        placeholder="About Aristo India"
                        value={contentWideBanner.heading || ''}
                        onChange={(e) => setContentWideBanner({ ...contentWideBanner, heading: e.target.value })}
                      />
                    </div>

                    <div className="form-group-custom">
                      <label className="label-custom">Description <span className="req">*</span></label>
                      <textarea 
                        className="textarea-custom"
                        rows={6}
                        placeholder="Write your company description here..."
                        value={contentWideBanner.description || ''}
                        onChange={(e) => setContentWideBanner({ ...contentWideBanner, description: e.target.value })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB 1: Meet Our Directors (Our Leadership) */}
          {activeTab === 1 && (
            <div className="tab-pane animate-fade-up">
              <h2 className="edit-about-panel-title">Meet Our Directors (Our Leadership)</h2>

              {/* Header Settings */}
              <div className="about-card-block">
                <div className="form-group-custom">
                  <label className="label-custom">Badge Tag <span className="opt">(e.g. OUR LEADERSHIP)</span></label>
                  <input 
                    type="text" 
                    className="input-custom"
                    placeholder="OUR LEADERSHIP"
                    value={directorsSection.tag || ''}
                    onChange={(e) => setDirectorsSection({ ...directorsSection, tag: e.target.value })}
                  />
                </div>

                <div className="form-group-custom">
                  <label className="label-custom">Main Heading <span className="req">*</span></label>
                  <input 
                    type="text" 
                    className="input-custom"
                    placeholder="Meet Our Directors"
                    value={directorsSection.heading || ''}
                    onChange={(e) => setDirectorsSection({ ...directorsSection, heading: e.target.value })}
                  />
                </div>

                <div className="form-group-custom">
                  <label className="label-custom">Section Description <span className="req">*</span></label>
                  <textarea 
                    className="textarea-custom"
                    rows={3}
                    placeholder="Guided by vision, driven by passion..."
                    value={directorsSection.description || ''}
                    onChange={(e) => setDirectorsSection({ ...directorsSection, description: e.target.value })}
                  />
                </div>
              </div>

              {/* Directors List */}
              <h3 style={{ color: '#c4a882', fontSize: '1.1rem', margin: '1.5rem 0 1rem 0', fontWeight: 600 }}>
                Directors Team ({directorsSection.directors.length})
              </h3>

              {directorsSection.directors.map((dir, dIdx) => (
                <div key={dir.id || dIdx} className="about-card-block" style={{ marginBottom: '1.5rem' }}>
                  <div className="card-header-bar">
                    <h3 className="card-header-title">Director {dIdx + 1}: {dir.name || 'Unnamed Director'}</h3>
                    <div className="card-header-actions">
                      <label className="switch-toggle" style={{ transform: 'scale(0.85)' }}>
                        <input 
                          type="checkbox" 
                          checked={dir.status === 1 || dir.status === '1'}
                          onChange={(e) => handleDirectorFieldChange(dIdx, 'status', e.target.checked ? 1 : 0)}
                        />
                        <span className="switch-slider"></span>
                      </label>
                      <button 
                        type="button" 
                        className="trash-btn"
                        onClick={() => handleRemoveDirector(dIdx)}
                        title="Remove Director"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </div>

                  {/* 1. Top Row: Left Image & Right Info (Name + Role) */}
                  <div style={{ display: 'grid', gridTemplateColumns: '220px minmax(0, 1fr)', gap: '1.5rem', alignItems: 'start', marginBottom: '1.25rem' }}>
                    {/* Left: Director Image */}
                    <div className="image-uploader-box">
                      <label className="label-custom">Director Photo <span className="req">*</span></label>
                      <div 
                        className="image-preview-wrapper"
                        style={{ height: '170px' }}
                        onClick={() => fileInputRefs.current[`dir_${dIdx}`]?.click()}
                      >
                        {dir.image ? (
                          <>
                            <img src={getImageUrl(dir.image)} alt={dir.name || 'Director'} className="uploaded-preview-img" style={{ objectFit: 'cover' }} />
                            <div className="image-delete-overlay" onClick={(e) => { e.stopPropagation(); handleDirectorFieldChange(dIdx, 'image', ''); }}>
                              <FaTrash />
                            </div>
                          </>
                        ) : (
                          <div className="upload-placeholder-content">
                            <FaCloudUploadAlt className="upload-icon" />
                            <span>Upload Photo</span>
                          </div>
                        )}
                      </div>
                      <input 
                        type="file" 
                        accept="image/*"
                        style={{ display: 'none' }}
                        ref={el => fileInputRefs.current[`dir_${dIdx}`] = el}
                        onChange={(e) => handleDirectorImageUpload(e, dIdx)}
                      />
                      <span className="dimensions-note">Portrait / Square photo</span>
                    </div>

                    {/* Right: Info Fields (Name & Role) */}
                    <div style={{ minWidth: 0, width: '100%', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                      <div className="form-group-custom" style={{ marginBottom: '0.75rem' }}>
                        <label className="label-custom">Director Name <span className="req">*</span></label>
                        <input 
                          type="text" 
                          className="input-custom"
                          placeholder="e.g. Mr. Sanjay Arora"
                          value={dir.name || ''}
                          onChange={(e) => handleDirectorFieldChange(dIdx, 'name', e.target.value)}
                        />
                      </div>

                      <div className="form-group-custom" style={{ marginBottom: 0 }}>
                        <label className="label-custom">Role / Designation <span className="req">*</span></label>
                        <input 
                          type="text" 
                          className="input-custom"
                          placeholder="e.g. Managing Director"
                          value={dir.role || ''}
                          onChange={(e) => handleDirectorFieldChange(dIdx, 'role', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  {/* 2. Full Width Bio / Description (Directly below both photo and name) */}
                  <div className="form-group-custom" style={{ marginBottom: '1.25rem' }}>
                    <label className="label-custom">Bio / Description <span className="req">*</span></label>
                    <textarea 
                      className="textarea-custom"
                      rows={4}
                      placeholder="Write director bio, experience and accomplishments..."
                      value={dir.bio || ''}
                      onChange={(e) => handleDirectorFieldChange(dIdx, 'bio', e.target.value)}
                    />
                  </div>

                  {/* 3. Luxury Social Media Profiles Bar */}
                  <div className="director-social-section">
                    <label className="label-custom" style={{ color: '#c4a882', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <span>Social Media Profiles</span>
                      <span className="opt">(Optional)</span>
                    </label>

                    <div className="director-social-grid">
                      {/* LinkedIn */}
                      <div className="social-input-wrapper">
                        <div className="social-icon-badge linkedin" title="LinkedIn">
                          <FaLinkedin />
                        </div>
                        <input 
                          type="text" 
                          className="social-input-field"
                          placeholder="LinkedIn Profile URL"
                          value={dir.linkedin || ''}
                          onChange={(e) => handleDirectorFieldChange(dIdx, 'linkedin', e.target.value)}
                        />
                      </div>

                      {/* Twitter / X */}
                      <div className="social-input-wrapper">
                        <div className="social-icon-badge twitter" title="Twitter / X">
                          <FaTwitter />
                        </div>
                        <input 
                          type="text" 
                          className="social-input-field"
                          placeholder="Twitter / X Profile URL"
                          value={dir.twitter || ''}
                          onChange={(e) => handleDirectorFieldChange(dIdx, 'twitter', e.target.value)}
                        />
                      </div>

                      {/* Instagram */}
                      <div className="social-input-wrapper">
                        <div className="social-icon-badge instagram" title="Instagram">
                          <FaInstagram />
                        </div>
                        <input 
                          type="text" 
                          className="social-input-field"
                          placeholder="Instagram Profile URL"
                          value={dir.instagram || ''}
                          onChange={(e) => handleDirectorFieldChange(dIdx, 'instagram', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="add-slide-block" style={{ marginTop: '1rem' }}>
                <button type="button" className="add-slide-btn" onClick={handleAddDirector}>
                  <FaPlus /> <span>Add Another Director</span>
                </button>
              </div>
            </div>
          )}

          {/* TAB 2: Left Image & Right Content */}
          {activeTab === 2 && (
            <div className="tab-pane animate-fade-up">
              <h2 className="edit-about-panel-title">Left Image & Right Content (Our Presence)</h2>
              
              <div className="about-card-block">
                {/* Top Row: Left Image & Right Title / Alt / Highlights */}
                <div style={{ display: 'grid', gridTemplateColumns: '220px minmax(0, 1fr)', gap: '1.5rem', alignItems: 'start', marginBottom: '1.25rem' }}>
                  {/* Left: Section Image */}
                  <div className="image-uploader-box">
                    <label className="label-custom">Section Image <span className="req">*</span></label>
                    <div 
                      className="image-preview-wrapper"
                      style={{ height: '170px' }}
                      onClick={() => fileInputRefs.current['leftRight']?.click()}
                    >
                      {leftImageRightContent.image ? (
                        <>
                          <img src={getImageUrl(leftImageRightContent.image)} alt={leftImageRightContent.alt || 'Section Image'} className="uploaded-preview-img" style={{ objectFit: 'contain' }} />
                          <div className="image-delete-overlay" onClick={(e) => { e.stopPropagation(); setLeftImageRightContent({ ...leftImageRightContent, image: '' }); }}>
                            <FaTrash />
                          </div>
                        </>
                      ) : (
                        <div className="upload-placeholder-content">
                          <FaCloudUploadAlt className="upload-icon" />
                          <span>Click to upload section image</span>
                        </div>
                      )}
                    </div>
                    <input 
                      type="file" 
                      accept="image/*"
                      style={{ display: 'none' }}
                      ref={el => fileInputRefs.current['leftRight'] = el}
                      onChange={(e) => handleImageFileChange(e, setLeftImageRightContent)}
                    />
                    <span className="dimensions-note">800 × 500 px (Max 1.5 MB)</span>
                  </div>

                  {/* Right: Section Title & (Alt Text + Highlights) */}
                  <div style={{ minWidth: 0, width: '100%', display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
                    <div className="form-group-custom" style={{ margin: 0 }}>
                      <label className="label-custom">Section Title <span className="req">*</span></label>
                      <input 
                        type="text" 
                        className="input-custom"
                        placeholder="Section Title"
                        value={leftImageRightContent.heading || ''}
                        onChange={(e) => setLeftImageRightContent({ ...leftImageRightContent, heading: e.target.value })}
                      />
                    </div>

                    {/* Alt Text & Highlights side-by-side */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem' }}>
                      <div className="form-group-custom" style={{ margin: 0 }}>
                        <label className="label-custom">Alt Text <span className="req">*</span></label>
                        <input 
                          type="text" 
                          className="input-custom"
                          placeholder="Alt Text (e.g. Map)"
                          value={leftImageRightContent.alt || ''}
                          onChange={(e) => setLeftImageRightContent({ ...leftImageRightContent, alt: e.target.value })}
                        />
                      </div>

                      <div className="form-group-custom" style={{ margin: 0 }}>
                        <label className="label-custom">Highlights <span className="opt">(Optional)</span></label>
                        <input 
                          type="text" 
                          className="input-custom"
                          placeholder="e.g. 15+ Years, 400+ Partners"
                          value={leftImageRightContent.highlights || ''}
                          onChange={(e) => setLeftImageRightContent({ ...leftImageRightContent, highlights: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom Row: Full Width Section Description */}
                <div className="form-group-custom" style={{ margin: 0 }}>
                  <label className="label-custom">Section Description <span className="req">*</span></label>
                  <textarea 
                    className="textarea-custom"
                    rows={6}
                    placeholder="Section Description..."
                    value={leftImageRightContent.description || ''}
                    onChange={(e) => setLeftImageRightContent({ ...leftImageRightContent, description: e.target.value })}
                  />
                  <span className="helper-text">Full width description text for the presence & brand story.</span>
                </div>
              </div>
            </div>
          )}

          {/* TAB 3: Our Foundation (Vision, Mission & Core Values) */}
          {activeTab === 3 && (
            <div className="tab-pane animate-fade-up">
              <h2 className="edit-about-panel-title">Our Foundation (Vision, Mission & Values)</h2>

              {/* Section Header Controls */}
              <div className="about-card-block">
                <div className="form-group-custom">
                  <label className="label-custom">Badge Tag <span className="opt">(e.g. OUR FOUNDATION)</span></label>
                  <input 
                    type="text" 
                    className="input-custom"
                    placeholder="OUR FOUNDATION"
                    value={foundationSection.tag || ''}
                    onChange={(e) => setFoundationSection({ ...foundationSection, tag: e.target.value })}
                  />
                </div>

                <div className="form-group-custom">
                  <label className="label-custom">Main Heading <span className="req">*</span></label>
                  <input 
                    type="text" 
                    className="input-custom"
                    placeholder="Vision. Mission. Values That Drive Us."
                    value={foundationSection.heading || ''}
                    onChange={(e) => setFoundationSection({ ...foundationSection, heading: e.target.value })}
                  />
                </div>
              </div>

              {/* Vision Settings Block */}
              <div className="about-card-block">
                <h3 style={{ color: '#c4a882', fontSize: '1.1rem', marginBottom: '1.25rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FaEye /> <span>Vision Details</span>
                </h3>

                <div className="form-group-custom">
                  <label className="label-custom">Vision Title <span className="req">*</span></label>
                  <input 
                    type="text" 
                    className="input-custom"
                    placeholder="Vision"
                    value={foundationSection.vision_title || ''}
                    onChange={(e) => setFoundationSection({ ...foundationSection, vision_title: e.target.value })}
                  />
                </div>

                <div className="form-group-custom">
                  <label className="label-custom">Vision Description <span className="req">*</span></label>
                  <textarea 
                    className="textarea-custom"
                    rows={3}
                    placeholder="To be the trusted leader in delivering the greatest experiences..."
                    value={foundationSection.vision_desc || ''}
                    onChange={(e) => setFoundationSection({ ...foundationSection, vision_desc: e.target.value })}
                  />
                </div>
              </div>

              {/* Mission Settings Block */}
              <div className="about-card-block">
                <h3 style={{ color: '#c4a882', fontSize: '1.1rem', marginBottom: '1.25rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FaBullseye /> <span>Mission Details & Goals</span>
                </h3>

                <div className="form-group-custom">
                  <label className="label-custom">Mission Title <span className="req">*</span></label>
                  <input 
                    type="text" 
                    className="input-custom"
                    placeholder="Mission"
                    value={foundationSection.mission_title || ''}
                    onChange={(e) => setFoundationSection({ ...foundationSection, mission_title: e.target.value })}
                  />
                </div>

                <div className="form-group-custom">
                  <label className="label-custom">Mission Points <span className="req">*</span> <span className="opt">(1 point per line)</span></label>
                  <textarea 
                    className="textarea-custom"
                    rows={4}
                    placeholder="Craftsmanship & Premium Design&#10;Customer-Centric Service&#10;Integrated Systems & Transparency&#10;Brand Tone"
                    value={foundationSection.mission_points || ''}
                    onChange={(e) => setFoundationSection({ ...foundationSection, mission_points: e.target.value })}
                  />
                  <span className="helper-text">Enter each mission bullet point on a new line</span>
                </div>
              </div>

              {/* Core Values Diagram Upload Block */}
              <div className="about-card-block">
                <h3 style={{ color: '#c4a882', fontSize: '1.1rem', marginBottom: '1.25rem', fontWeight: 600 }}>
                  Core Values Diagram Graphic <span className="opt">(Right Side Wheel/Graphic)</span>
                </h3>

                <div className="card-content-grid">
                  <div className="image-uploader-box">
                    <label className="label-custom">Values Graphic <span className="opt">(Optional - defaults to Core Values Wheel)</span></label>
                    <div 
                      className="image-preview-wrapper"
                      style={{ height: '180px' }}
                      onClick={() => fileInputRefs.current['foundationImg']?.click()}
                    >
                      {foundationSection.image ? (
                        <>
                          <img src={getImageUrl(foundationSection.image)} alt="Core Values" className="uploaded-preview-img" style={{ objectFit: 'contain' }} />
                          <div className="image-delete-overlay" onClick={(e) => { e.stopPropagation(); setFoundationSection({ ...foundationSection, image: '' }); }}>
                            <FaTrash />
                          </div>
                        </>
                      ) : (
                        <div className="upload-placeholder-content">
                          <FaCloudUploadAlt className="upload-icon" />
                          <span>Upload Custom Values Graphic</span>
                        </div>
                      )}
                    </div>
                    <input 
                      type="file" 
                      accept="image/*"
                      style={{ display: 'none' }}
                      ref={el => fileInputRefs.current['foundationImg'] = el}
                      onChange={(e) => handleImageFileChange(e, setFoundationSection, 'image')}
                    />
                    <span className="dimensions-note">PNG / SVG transparent graphic recommended</span>
                  </div>

                  <div style={{ minWidth: 0, width: '100%' }}>
                    <div className="form-group-custom">
                      <label className="label-custom">Alt Text</label>
                      <input 
                        type="text" 
                        className="input-custom"
                        placeholder="Core Values Diagram"
                        value={foundationSection.alt || ''}
                        onChange={(e) => setFoundationSection({ ...foundationSection, alt: e.target.value })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB 4: SEO Manager */}
          {activeTab === 4 && (
            <div className="tab-pane animate-fade-up">
              <h2 className="edit-about-panel-title">SEO Manager</h2>
              
              <div className="about-card-block">
                <div className="form-group-custom">
                  <label className="label-custom">Meta Title <span className="req">*</span></label>
                  <input 
                    type="text" 
                    className="input-custom"
                    value={seo.meta_title}
                    onChange={(e) => setSeo({ ...seo, meta_title: e.target.value })}
                  />
                </div>

                <div className="form-group-custom">
                  <label className="label-custom">Meta Description <span className="req">*</span></label>
                  <textarea 
                    className="textarea-custom"
                    rows={4}
                    value={seo.meta_description}
                    onChange={(e) => setSeo({ ...seo, meta_description: e.target.value })}
                  />
                </div>

                <div className="form-group-custom">
                  <label className="label-custom">Meta Keywords</label>
                  <input 
                    type="text" 
                    className="input-custom"
                    value={seo.meta_keywords}
                    onChange={(e) => setSeo({ ...seo, meta_keywords: e.target.value })}
                  />
                  <span className="helper-text">Add commas to separate keywords</span>
                </div>
              </div>
            </div>
          )}
            </>
          )}

        </div>

      </div>

      {/* Footer Action Bar */}
      <div className="edit-about-footer">
        <button 
          type="button" 
          className="btn-cancel"
          onClick={() => navigate('/page-list')}
        >
          Cancel
        </button>
        <button 
          type="button" 
          className="btn-save"
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default EditAbout;
